var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 81,
    viewBox: "0 0 79 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 96",
    x: 3,
    y: 3.29065,
    width: 72.6047,
    height: 74.0683,
    rx: 16,
    stroke: "#FF9595",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.948 45.5963L52.9472 59.5956C53.69 60.3384 54.6976 60.7557 55.7481 60.7557C56.7986 60.7557 57.8062 60.3384 58.549 59.5956C59.2918 58.8527 59.7092 57.8452 59.7092 56.7947C59.7092 55.7441 59.2918 54.7366 58.549 53.9937L44.5445 39.9945L58.5464 25.9953C58.914 25.6275 59.2056 25.1908 59.4045 24.7103C59.6034 24.2298 59.7057 23.7148 59.7056 23.1948C59.7055 22.6747 59.6029 22.1598 59.4038 21.6794C59.2047 21.1989 58.9129 20.7624 58.545 20.3948C58.1772 20.0272 57.7406 19.7356 57.2601 19.5367C56.7796 19.3378 56.2646 19.2354 55.7445 19.2356C55.2245 19.2357 54.7095 19.3382 54.2291 19.5374C53.7487 19.7365 53.3122 20.0283 52.9446 20.3961L38.948 34.3954L24.9487 20.3961C24.5836 20.0178 24.1468 19.7159 23.6638 19.5081C23.1808 19.3004 22.6612 19.1909 22.1355 19.1861C21.6097 19.1813 21.0882 19.2812 20.6015 19.4801C20.1148 19.679 19.6725 19.9728 19.3005 20.3444C18.9286 20.716 18.6343 21.158 18.435 21.6445C18.2357 22.1311 18.1352 22.6525 18.1395 23.1782C18.1439 23.704 18.2528 24.2237 18.4601 24.7069C18.6674 25.1901 18.9689 25.6272 19.3469 25.9926L33.3514 39.9945L19.3496 53.9964C18.9715 54.3619 18.6701 54.7989 18.4628 55.2821C18.2555 55.7654 18.1465 56.285 18.1422 56.8108C18.1379 57.3366 18.2383 57.8579 18.4376 58.3445C18.637 58.831 18.9312 59.273 19.3032 59.6446C19.6751 60.0163 20.1174 60.3101 20.6041 60.509C21.0909 60.7078 21.6123 60.8078 22.1381 60.803C22.6639 60.7981 23.1834 60.6887 23.6665 60.4809C24.1495 60.2732 24.5863 59.9713 24.9514 59.5929L38.948 45.5963Z",
    fill: "#FF9595"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIcon);
export default __webpack_public_path__ + "static/media/reject-icon.022573a47ad0235f2622b0fb233a66c8.svg";
export { ForwardRef as ReactComponent };